import { store } from './../index';
import { logOtherInfo, detailsInfo } from './../serviceSMB/logService';
import { redirectTo } from './../actionSMB/redirection';

export class Utils {
  static isNull(value) {
    if (value === undefined || value === null) {
      return true;
    }
    return false;
  }

  static isNotNull(value) {
    if (typeof value !== 'string' && value !== undefined && value !== null) {
      return true;
    } else if (typeof value === 'string' && value !== undefined) {
      return true;
    }
    return false;
  }

  static isNotEmpty(value) {
    if (value !== undefined && value !== null && value !== '') {
      return true;
    }
    return false;
  }

  // static isNotNullObjects(obj /*, level1, level2, ... levelN*/) {
  //     try {
  //         var args = Array.prototype.slice.call(arguments, 1);

  //         for (var i = 0; i < args.length; i++) {
  //             if (!obj || !obj.hasOwnProperty(args[i])) {
  //                 return false;
  //             }
  //             obj = obj[args[i]];
  //         }
  //         return true;
  //     }
  //     catch (e) { return false; }
  // }

  // static arrayIncludes(array, value) {
  //     if (array.includes) {
  //         return array.includes(value);
  //     }
  //     else {
  //         return array.indexOf(value) > -1 ? true : false;
  //     }
  // }

  static removeSpecialChars(str) {
    let newstr = str.toLowerCase();
    return newstr
      .replace(/(?!\w|\s)./g, '')
      .replace(/\s+/g, '-')
      .replace(/^(\s*)([\W\w]*)(\b\s*$)/g, '$2');
  }

  // static modifyUrl(str){
  //     let m,n,
  //         urls = [],url=[],
  //         rex = /<img[^>]+src="?([^"\s]+)"?\s*\/>/g,
  //         reg=/<a\s+(?:[^>]*?\s+)?href=(["'])(.*?)\1/g;

  //     while ( m === rex.exec( str ) ) {
  //         urls.push( m[1] );
  //     }
  //     while ( n === reg.exec( str ) ) {
  //         url.push( n[2] );
  //     }
  //     for(let i=0;i<urls.length;i++){
  //      str=str.replace(urls[i],Utils.getDomainUrl()+urls[i])
  //     }
  //    if(url.length>0){
  //      str=str.replace(url[0],Utils.getDomainUrl()+url[0])
  //     }
  //     return str

  // }

  static clearMemory() {
    let visitId = store.getState().app.visitId;
    let pageName = store.getState().app.currentPage.pathname;
    logOtherInfo(detailsInfo(pageName, visitId, 'clearMemory', 'Clearing both cookie and redux', 'USERACTION'));
    window.sessionStorage.clear();
    window.localStorage.clear();
    clearCookies();
    store.dispatch({ type: 'CLEAR_STORE', value: null });
  }

  static clearRedux(...storesToClear) {
    for (let i = 0; i < storesToClear.length; i++) {
      let state = storesToClear[i];
      if ('null' !== state) {
        let stateUpperCase = state.toUpperCase();
        let typeData = 'CLEAR_'.concat(stateUpperCase);
        store.dispatch({ type: typeData, value: null });
      }
    }
  }

  static redirectToHomePage() {
    redirectTo('/smallbusiness/accessories', store.dispatch);
  }
  static isMobileView() {
    let userAgent = window.navigator.userAgent.toLowerCase();
    if (userAgent && (userAgent.indexOf('android') !== -1 || userAgent.indexOf('iphone') !== -1)) {
      return true;
    }
  }
  static getBrowserType() {
    let userAgent = window.navigator.userAgent.toLowerCase();
    let browserType;
    if (userAgent.indexOf('trident') !== -1) {
      browserType = 'internet explorer';
    } else if (userAgent.indexOf('firefox') !== -1) {
      browserType = 'firefox';
    } else if (userAgent.indexOf('edge') !== -1 || userAgent.indexOf('edg') !== -1) {
      browserType = 'edge';
    } else if (userAgent.indexOf('chrome') !== -1) {
      browserType = 'chrome';
    } else if (userAgent.indexOf('safari') !== -1) {
      browserType = 'safari';
    } else {
      browserType = 'other';
    }
    return browserType;
  }
  static getDomainUrl(env = '') {
    let domainURL = window.location.origin;
    if (
      domainURL === 'https://www.verizon.com' ||
      domainURL === 'https://wwwv05g-vtp-east-yz.vpc.verizon.com' ||
      domainURL === 'https://wwwv05g-vtp-west-yz.vpc.verizon.com'
    ) {
      domainURL = 'https://www.verizon.com';
    } else if (domainURL === 'https://espanol.verizon.com') {
      domainURL = 'https://www.verizon.com';
    } else if (domainURL === 'https://orderinglite-gz-east.vpc.verizon.com') {
      domainURL = 'https://www98.verizon.com';
    } else if (domainURL === 'https://preprod-east-gz.vpc.verizon.com') {
      domainURL = 'https://www.verizon.com';
    } else if (domainURL === 'https://www98.verizon.com') {
      domainURL = 'https://www.verizon.com';
    }
    //else if(domainURL === "https://wwwv05g-vtp-east-yz.vpc.verizon.com"){
    //domainURL = "https://wwwv05g-vtp-east-yz.vpc.verizon.com"
    //}
    else if (domainURL === 'https://sso-pr-east-yz.vpc.verizon.com') {
      domainURL = 'https://www.verizon.com';
    } 
    else if (domainURL === 'https://wwwawssit.ebiz.verizon.com') {
      domainURL = 'https://wwwawssit.ebiz.verizon.com';
      // domainURL = 'https://www.verizon.com';
    } 
    else if (domainURL === 'https://wwwnte1aws.ebiz.verizon.com') {
        domainURL = 'https://wwwnte1aws.ebiz.verizon.com';
    }
    else {
      domainURL = 'https://www.verizon.com';
    }
    return domainURL;
  }
  static getContentPath(contentPath) {
    let actualContentPath = '';
    let domainURL = window.location.origin;
   
    if (contentPath.indexOf('/www.adobe.com/') > -1 || contentPath.indexOf('/www.verizon.com/') > -1) {
      actualContentPath = contentPath;
    }
    else if(contentPath.indexOf('/smallbusiness/accessories/') > -1){
      actualContentPath = Utils.getDomainUrl().concat(contentPath);
    } 
    else {
      actualContentPath = 'https://ss7.vzw.com/is/content/VerizonWireless/' + contentPath;
    }
    
    return actualContentPath;
  }
  static getImagePath(imagePath) {
    let actualImagePathInfo = '';
    let domainURL = window.location.origin;
    if (imagePath.indexOf('/home/accessories/media/') > -1) {
      if (domainURL == 'http://localhost:3000') {
        actualImagePathInfo = 'https://ss7.vzw.com/is/image/VerizonWireless/' + imagePath;
      } else {
        actualImagePathInfo = Utils.getDomainUrl().concat(imagePath);
      }
    } else {
      actualImagePathInfo = 'https://ss7.vzw.com/is/image/VerizonWireless/' + imagePath;
    }
    return actualImagePathInfo;
  }
}

function clearCookies() {
  var cookies = document.cookie.split('; ');
  for (var c = 0; c < cookies.length; c++) {
    var d = window.location.hostname.split('.');
    while (d.length > 0) {
      var cookieBase =
        encodeURIComponent(cookies[c].split(';')[0].split('=')[0]) + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=' + d.join('.') + ' ;path=';
      var p = window.location.pathname.split('/');
      document.cookie = cookieBase + '/';
      while (p.length > 0) {
        document.cookie = cookieBase + p.join('/');
        p.pop();
      }
      d.shift();
    }
  }
}
